<template>
  <div class="card_container mx-auto">
    <v-col class="pa-5 pt-6 pb-8">
      <toolbar-titles :title="$tc('nav.report')" />
    </v-col>

    <div v-if="buttonSelected === 0">
      <TableWithSearch
        :showFilterTags="true"
        :tags="getTags"
        :showIcon="true"
        :items="getReports"
        :title="title"
        :headers="allHeaders"
        :openDialog="openDialog"
        :executeButtonEnabled="itemHasParameters"
        @headersUpdated="updateHeaders"
        @refreshItems="refreshItems"
      />
      <v-dialog v-model="showForm" fullscreen persistent>
        <Form
          ref="formComponent"
          :mode="mode"
          @save="saveForm"
          @cancel="reset"
          :allFields="itemsReports.allFields"
        />
      </v-dialog>
      <delete-dialog
        :title="$tc('reports.deleteReport')"
        :showDialog="showDelete"
        :cancelDelete="cancelDelete"
        :confirmDelete="confirmDelete"
      />
      <v-dialog v-model="showExecute" class="red" max-width="550px" persistent>
        <execute
          @save="saveFormExecute"
          @cancel="resetExecute"
          :parameters="parameters"
          :data="parametersData"
          :key="key"
        />
      </v-dialog>
      <v-dialog v-model="showPermissions" max-width="600px" persistent>
        <permissions
          @cancel="resetPermissions"
          :parameters="parameters"
          :data="idEdit"
          :key="key"
        />
      </v-dialog>

      <v-dialog v-model="showTableExecute" fullscreen persistent>
        <DataExecute :parameters="parameters" :data="parametersData" />
      </v-dialog>
      <Snackbar
        :alert="showSnackbar"
        :textAlert="textSnackbar"
        :color="colorSnackbar"
      />
    </div>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </div>
</template>
<script>
import TableWithSearch from "./commons/Table.vue";
import ToolbarTitles from "../Complement/ToolbarTitles.vue";
import reports from "../../store/reportes/reports";
import Form from "./Form.vue";
import DeleteDialog from "../Complement/DeleteDialog.vue";
import Snackbar from "../Complement/Snackbar.vue";
import Execute from "./Execute.vue";
import Permissions from "./Permissions.vue";
import moment from "moment";
import DataExecute from "./DataExecute.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import Loader from "../Complement/Loader.vue";

export default {
  name: "Reports",
  components: {
    ToolbarTitles,
    TableWithSearch,
    Form,
    DeleteDialog,
    Snackbar,
    Execute,
    Permissions,
    DataExecute,
    Loader,
  },
  data() {
    return {
      buttonSelected: 0,
      title: this.$tc("nav.report"),
      titleForm: this.$tc("reports.addReport"),
      isLoading: true,
      loadingKey: 0,
      headers: {
        reportes: [
          {
            text: "Nombre",
            value: "name",
            align: "start",
            class: "primary secondary--text",
            width: "20%",
            visible: true,
          },
          {
            text: "Descripción",
            align: "start",
            value: "description",
            class: "primary secondary--text",
            width: "30%",
            visible: true,
          },
          {
            text: "Tipo",
            value: "type",
            class: "primary secondary--text",
            align: "start",
            visible: true,
            width: "10%",
            sortable: false,
          },
          {
            text: "Etiquetas",
            value: "tags",
            class: "primary secondary--text",
            align: "start",
            visible: true,
            width: "25%",
            sortable: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            align: "start",
            width: "15%",
          },
        ],
        parametros: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Tipo",
            value: "typeTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Requerido",
            value: "requiredTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Largo",
            value: "length",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Lookup",
            value: "lookup",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "LookupMultiple",
            value: "lookupMultiple",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            sortable: false,
            visible: true,
            width: "90px",
          },
        ],
      },

      showForm: false,
      showDelete: false,
      itemDelete: null,
      showSnackbar: false,
      textSnackbar: "",
      colorSnackbar: "",
      type: null,
      idEdit: null,
      parameters: null,
      showExecute: false,
      showPermissions: false,
      idParams: null,
      parametersData: null,
      key: 0,
    };
  },
  mounted() {
    localStorage.setItem("dataReport", false);
    configTable.commit("setColums", []);
    let nameTable = this.title;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          Object.values(this.allColums).reduce(
            (sum, array) => sum + array.length,
            0,
          ) !==
            Object.values(this.headers).reduce(
              (sum, array) => sum + array.length,
              0,
            )
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    Promise.all([
      this.$store.dispatch("tags/getTags"),
      reports.dispatch("getReports"),
      reports.dispatch("getProcedures"),
    ])
      .then(() => {
        // All three dispatches have completed successfully
        this.isLoading = false;
      })
      .catch((error) => {
        // Handle any errors that occurred during the dispatches
        console.error("Error during dispatches:", error);
      });
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.reportes || [];
    },
    allColums() {
      return configTable.state.colums;
    },
    getReports() {
      return reports.state.reports;
    },
    getTags() {
      return this.$store.state.tags.tags.filter(
        (tag) => tag.scope === "reportes",
      );
    },
    itemsReports() {
      return {
        allFields: [
          {
            data: "",
            name: "name",
            type: "text",
            label: "Nombre",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 1,
          },
          {
            data: "",
            name: "description",
            type: "text",
            label: "Descripción",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 2,
          },
          {
            data: "",
            name: "process",
            type: "select",
            label: "Procedimiento",
            items: this.getProcedures,
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 3,
          },
          {
            data: null,
            name: "type",
            type: "select",
            label: "Tipo de reporte",
            items: [
              { text: "Público", id: "Pu" },
              { text: "Privado", id: "Pr" },
            ],
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 5,
          },
          {
            data: null,
            name: "tags",
            type: "autocomplete",
            label: "Seleccione una etiqueta",
            items: this.getTags,
            rules: [],
            order: 6,
          },
        ],
      };
    },
    mode: {
      get() {
        return reports.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    getProcedures() {
      return reports.state.procedures;
    },
    showTableExecute() {
      return reports.state.showTableExecute;
    },
  },
  methods: {
    async refreshItems() {
      await reports.dispatch("getReports");
    },
    updateHeaders(headers) {
      const updatedColums = { ...configTable.state.colums, reportes: headers };
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },

    getTagsForAutocomplete() {
      return this.getTags.map((tag) => {
        return {
          text: tag.text,
          value: tag.id, // O cualquier otra propiedad que desees usar como valor
        };
      });
    },
    forceMounted() {
      configTable.commit("setColums", []);
      let nameTable = this.title;
      configTable
        .dispatch("getColumsTableName", nameTable)
        .then(() => {
          if (
            configTable.state.colums.length === 0 ||
            configTable.state.colums.length !== this.headers.length
          ) {
            this.saveConfigColumns();
          }
        })
        .catch((error) => {
          console.error("Error occurred:", error);
        });
      this.$store.dispatch("tags/getTags");
      reports.dispatch("getReports");
      reports.dispatch("getProcedures");
    },

    async showReport() {
      this.forceMounted();
      this.loading = true;
      this.loadingKey++;
      await reports.dispatch("getReports");

      this.$nextTick(() => {
        this.buttonSelected = 0;
        this.loading = false;
      });
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        Object.values(this.allColums).reduce(
          (sum, array) => sum + array.length,
          0,
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0,
          ) ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openDialog(type, item) {
      switch (type) {
        case "add":
          this.showForm = true;
          reports.commit("setMode", this.$tc("reports.addReport"));
          reports.commit("setItemsTable", []);
          this.type = type;

          break;
        case "edit":
          this.showForm = true;
          reports.commit("setMode", this.$tc("reports.editReport"));
          this.itemsReports.allFields.forEach((element) => {
            if (element.name === "type") {
              element.data = item.type === "Privado" ? "Pr" : "Pu";
            } else if (element.name === "tags") {
              element.data = item.tags.map((tag) => {
                return tag.etiquetaId;
              });
            } else {
              element.data = item[element.name];
            }
          });
          this.type = type;
          this.idEdit = item.id;

          let json;

          if (
            typeof item.parameters === "string" ||
            item.parameters === "char"
          ) {
            json = JSON.parse(item.parameters);
          } else {
            json = item.parameters;
          }

          if (json !== null) {
            json.forEach((objeto, index) => {
              if (objeto.hasOwnProperty("required")) {
                objeto.requiredTable = objeto.required ? "✔️" : "";
              } else {
                objeto.required_table = "N/A";
              }
              objeto.index = index;
            });
          } else {
            json = [];
          }

          reports.commit("setItemsTable", json);
          break;
        case "delete":
          this.showDelete = true;
          this.itemDelete = item;
          break;
        case "exe":
          this.parametersData = {
            name: item.name,
            description: item.description,
          };
          this.parseParameters(item);
          this.showExecute = true;
          this.idParams = item.id;
          this.key++;
          break;
        case "pass":
          this.loading = true;
          reports.dispatch("getReportPermissions", item.id).then(() => {
            this.showPermissions = true;
            this.loading = false;
          });

          this.idEdit = item.id;
          this.key++;
          break;

        default:
          break;
      }
    },
    itemHasParameters(item) {
      return item && item.parameters && item.parameters.length > 0;
    },
    parseParameters(item) {
      if (typeof item.parameters === "string") {
        this.parameters = JSON.parse(item.parameters);
      } else {
        this.parameters = item.parameters;
      }
      this.defaultValue();
    },
    defaultValue() {
      const today = moment().format("YYYY-MM-DD");
      this.parameters?.forEach((element) => {
        element.data =
          element.defaultValue == "**" ? today : element.defaultValue;
      });
    },
    cancelDelete() {
      this.showDelete = false;
      setTimeout(() => {
        this.alert("", "", false);
      }, 3000);
    },
    confirmDelete() {
      reports.commit("setDeleteItem", this.itemDelete);
      reports
        .dispatch("delete")
        .then(() => {
          this.alert(this.$tc("reports.deleteReportSuccess"), "primary", true);
        })
        .catch((e) => {
          this.alert(e.response.data.error.message, "error", true);
        });
      this.cancelDelete();
    },
    saveForm(item) {
      switch (this.type) {
        case "add":
          this.addReport(item);
          break;
        case "edit":
          this.editReport(item);
          break;
        default:
          break;
      }
    },
    editReport(item) {
      const payload = {
        id: this.idEdit,
        ...item,
      };
      reports.commit("setEdit", payload);
      reports
        .dispatch("edit")
        .then(() => {
          this.alert(this.$tc("reports.editReportSuccess"), "primary", true);
          reports.commit("setEdit", []);
          reports.dispatch("getReports");
        })
        .catch((e) => {
          this.alert(e.response.data.error.message, "error", true);
        });
      this.reset(false);
    },
    addReport(item) {
      reports.commit("setNew", item);
      reports
        .dispatch("new")
        .then(() => {
          this.alert(this.$tc("reports.saveReportSuccess"), "primary", true);
          reports.commit("setItemsTable", []);
          reports.commit("setNew", []);
          reports.dispatch("getReports");
        })
        .catch((e) => {
          this.alert(e.response.data.error.message, "error", true);
        });
      this.reset(false);
    },
    reset(value) {
      this.$refs.formComponent.resetReports();
      this.showForm = value;
      this.itemsReports.allFields.forEach((element) => {
        element.data = "";
      });
    },
    alert(text, color, alert) {
      this.showSnackbar = alert;
      this.textSnackbar = text;
      this.colorSnackbar = color;
      setTimeout(() => {
        this.showSnackbar = false;
      }, 3000);
    },

    normalizeForBackend(payload) {
      const copy = JSON.parse(JSON.stringify(payload));
      if (!Array.isArray(copy.params)) return copy;
      copy.params = copy.params.map((p) => {
        const item = { ...p };
        if (
          typeof item.value === "string" &&
          moment(item.value, "DD-MM-YYYY", true).isValid()
        ) {
          item.value = moment(item.value, "DD-MM-YYYY").format("YYYY-MM-DD");
        }
        return item;
      });
      return copy;
    },

    async saveFormExecute(items) {
      this.isLoading = true;
      let copyItems = this.normalizeForBackend(items);

      this.parseItemsExecute(copyItems);

      const payload = {
        reporteId: this.idParams,
        ...copyItems,
        params: copyItems.params.map(({ name, value }) => ({ name, value })),
      };

      reports.commit("setExecute", payload);
      reports
        .dispatch("execute")
        .then(() => {
          reports.commit("setShowTableExecute", true);
          this.alert(this.$tc("reports.executeReportSuccess"), "primary", true);
          this.isLoading = false;
        })
        .catch((e) => {
          console.info(e);
          this.alert(e.response.data.error.message, "error", true);
          this.isLoading = false;
        });
      this.resetExecute(false);
    },
    resetExecute(item) {
      this.showExecute = item;
      this.parameters.forEach((element) => {
        element.data = "";
      });
    },
    resetPermissions(item) {
      reports.dispatch("getReports");
      this.showPermissions = item;
      this.editReport = null;
    },
    parseItemsExecute(items) {
      reports.commit("setExeParams", items);
    },
  },
};
</script>
<style scoped>
.card_container {
  max-width: 100%;
}
</style>
